import { ServiceDataFields } from './service-data-fields.enum';

export const venisafeMaternaFieldSet = [
  ServiceDataFields.PatientHistoryInformation,
  ServiceDataFields.CardiovascularConditions,
  ServiceDataFields.CardiovascularConditionsInFamilyHistory,
  ServiceDataFields.ParaAndGravida,
];
